/* eslint-disable @typescript-eslint/naming-convention */
import { Box, Typography } from '@astro-ui/components'
import { StatusValueEnum } from 'features/SupplyOrder/services/outboundSO'

type StatusConfigType = {
  label: string
  textColor: string
  bgColor: string
  borderColor: string
}

export const STATUS_CONFIG: Record<StatusValueEnum, StatusConfigType> = {
  CREATED: {
    label: 'Dibuat',
    textColor: '#23575C',
    bgColor: '#DEF7FA',
    borderColor: '#BCF0F5',
  },
  NEW: {
    label: 'Baru',
    textColor: '#23575C',
    bgColor: '#DEF7FA',
    borderColor: '#BCF0F5',
  },
  PICKING: {
    label: 'Picking',
    textColor: '#804300',
    bgColor: '#FFF3E6',
    borderColor: '#FFE7CC',
  },
  PACKING: {
    label: 'Packing',
    textColor: '#804300',
    bgColor: '#FFF3E6',
    borderColor: '#FFE7CC',
  },
  STAGING: {
    label: 'Staging',
    textColor: '#34245E',
    bgColor: '#F0EDF8',
    borderColor: '#E1DAF1',
  },
  LOADING: {
    label: 'Loading',
    textColor: '#34245E',
    bgColor: '#F0EDF8',
    borderColor: '#E1DAF1',
  },
  'READY TO SHIP': {
    label: 'Siap Kirim',
    textColor: '#34245E',
    bgColor: '#F0EDF8',
    borderColor: '#E1DAF1',
  },
  'ON DELIVERY': {
    label: 'Pengiriman',
    textColor: '#804300',
    bgColor: '#FFF3E6',
    borderColor: '#FFE7CC',
  },
  DELIVERED: {
    label: 'Dikirim',
    textColor: '#00552E',
    bgColor: '#E6F7EF',
    borderColor: '#CCEEDE',
  },
  'IN PROGRESS': {
    label: 'Dalam Proses',
    textColor: '#804300',
    bgColor: '#FFF3E6',
    borderColor: '#FFE7CC',
  },
  COMPLETED: {
    label: 'Selesai',
    textColor: '#00552E',
    bgColor: '#E6F7EF',
    borderColor: '#CCEEDE',
  },
  CANCELLED: {
    label: 'Dibatalkan',
    textColor: '#611919',
    bgColor: '#F9E6E6',
    borderColor: '#F2CCCC',
  },
}

type SupplyOrderStatusChipPropsType = {
  status: StatusValueEnum
}

const SupplyOrderStatusChip = ({ status }: SupplyOrderStatusChipPropsType) => {
  if (!status) return null

  const config = STATUS_CONFIG?.[status.replace('_', ' ') as StatusValueEnum] || {
    label: status,
    textColor: '#212121',
    bgColor: '#E9E9E9',
    borderColor: '#D3D3D3',
  }

  const backgroundColor = config.bgColor
  const { textColor } = config
  const { borderColor } = config

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      px="12px"
      py="4px"
      borderRadius="32px"
      border="1px solid"
      borderColor={borderColor}
      bg={backgroundColor}
    >
      <Typography variant="body-smallStrong" sx={{ color: textColor }} whiteSpace="nowrap">
        {config.label}
      </Typography>
    </Box>
  )
}

export default SupplyOrderStatusChip
